import React from 'react';

import SolutionDetailContainer from './SolutionDetail.container';
import SolutionDetailView from './SolutionDetail.view';
import SolutionDetailWithPassageView from './SolutionDetailWithPassage.view';

const SolutionDetail = ({ solutionData, variant }) => {
  return (
    <SolutionDetailContainer solutionData={solutionData}>
      {({
        onBack,
        isFirstQuestion,
        isLastQuestion,
        onGoToNextQuestion,
        onGoToPreviousQuestion,
        solutionContent,
        questionContent,
        questionNo,
        result,
        selectedAnswer,
        isShowScore,
        score,
        passage,
      }) => {
        if (passage) {
          return (
            <SolutionDetailWithPassageView
              variant={variant}
              questionNo={questionNo}
              onBack={onBack}
              onPreviousQuestion={onGoToPreviousQuestion}
              onNextQuestion={onGoToNextQuestion}
              solutionContent={solutionContent}
              questionContent={questionContent}
              result={result}
              isFirstQuestion={isFirstQuestion}
              isLastQuestion={isLastQuestion}
              selectedAnswer={selectedAnswer}
              isShowScore={isShowScore}
              score={score}
              passage={passage}
            />
          );
        } else {
          return (
            <SolutionDetailView
              variant={variant}
              questionNo={questionNo}
              onBack={onBack}
              onPreviousQuestion={onGoToPreviousQuestion}
              onNextQuestion={onGoToNextQuestion}
              solutionContent={solutionContent}
              questionContent={questionContent}
              result={result}
              isFirstQuestion={isFirstQuestion}
              isLastQuestion={isLastQuestion}
              selectedAnswer={selectedAnswer}
              isShowScore={isShowScore}
              score={score}
            />
          );
        }
      }}
    </SolutionDetailContainer>
  );
};

export default SolutionDetail;
